import {createSlice} from "@reduxjs/toolkit"
import { getByHash, getDiscount } from "../profile/profileSlice"

type AgentSliceState = {

   id: number
   discount: number
   first_name: string,
   last_name: string,
   subname: string
   
}

const initialState: AgentSliceState = {
    id: 0,
    discount: 0,
    first_name: "",
    last_name: "",
    subname: ""
}


export const AgentSlice = createSlice({
    name: "agent",
    initialState,
    reducers: {
        resetAgent: state => {
            state.id = initialState.id
            state.discount = initialState.discount
        }
    },
    extraReducers: (builder) => {
        //CHECK ALDERY PATIENT EXISTS
        builder.addCase(getByHash.fulfilled, (state, action) => {
            state.id = action.payload.docId      
        })
        builder.addCase(getDiscount.fulfilled, (state, action) => {
            state.discount = action.payload.discount
            state.first_name = action.payload.first_name
            state.last_name = action.payload.last_name
            state.subname = action.payload.subname  
        })
    }
})

export const {
   resetAgent
} = AgentSlice.actions


export const agentReducer = AgentSlice.reducer